module.exports = __webpack_public_path__ + "img/lang.26f98575.svg";